import { render, staticRenderFns } from "./OrphanGiftOrder.vue?vue&type=template&id=0237a0c0&scoped=true&"
import script from "./OrphanGiftOrder.vue?vue&type=script&lang=js&"
export * from "./OrphanGiftOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237a0c0",
  null
  
)

export default component.exports